<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bulb`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.955 31.565C9.369 26.969 7 22.615 7 18.44 7 8.821 14.598 1 24 1c9.402 0 17 7.821 17 17.441 0 4.174-2.369 8.529-6.955 13.124A7 7 0 0032 36.51v.46c0 1.66-1.33 3.03-3 3.03H19c-1.67 0-3-1.37-3-3.03v-.46a7 7 0 00-2.045-4.945zm17.259-2.826C35.122 24.823 37 21.371 37 18.441 37 11.005 31.166 5 24 5s-13 6.005-13 13.441c0 2.93 1.878 6.382 5.786 10.298A11 11 0 0119.988 36h8.024a11 11 0 013.202-7.26zM18 42a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2a1 1 0 00-1-1H18z"/></svg>
</template>
<script>

export default {
  name: 'IconBulb',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
